import { ClusterRolesState, ClusterRolesActions } from './clusterRoles.types';

const initialState = { status: 'idle', data: [], error: '' } as ClusterRolesState;

const clusterRolesReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: ClusterRolesActions
): typeof initialState => {
  switch (action.type) {
    case 'CREATE_CLUSTER_ROLE_SUCCESS': {
      const updatedClusterRoles = [...state.data, action.payload];

      return {
        ...state,
        data: updatedClusterRoles
      };
    }

    case 'UPDATE_CLUSTER_ROLE_REQUEST': {
      return {
        ...state,
        data: state.data.map((role) => {
          if (role.id === action.payload.clusterRole.id) {
            return {
              ...role,
              ...action.payload,
              serverStatus: 'pending'
            };
          }

          return role;
        })
      };
    }
    case 'UPDATE_CLUSTER_ROLE_SUCCESS': {
      return {
        ...state,
        data: state.data.map((role) => {
          if (role.id === action.payload.id) {
            return {
              ...role,
              ...action.payload,
              serverStatus: 'resolved'
            };
          }

          return role;
        })
      };
    }

    default:
      return state;
  }
};

export default clusterRolesReducer;
